import React, { FunctionComponent } from 'react';

import { InfoCard } from '@components/limits/usage_info_card/UsageInfoCard';

import './styles/subscription_dashboard.scss';

import SubscriptionFeatures from './SubscriptionFeatures/SubscriptionFeatures';
import SubscriptionHeader from './SubscriptionHeader/SubscriptionHeader';
import SubscriptionInfoCards from './SubscriptionInfoCards/SubscriptionInfoCards';

export interface Organization {
  name: string;
  slug: string;
}

interface SubscriptionsDashboardProps {
  featureStatuses: { [key: string]: boolean };
  organization: Organization;
  subscriptionInfoCards: InfoCard[]
}

const SubscriptionsDashboard: FunctionComponent<SubscriptionsDashboardProps> = ({
  featureStatuses,
  organization,
  subscriptionInfoCards
}) =>
  <>
    <SubscriptionHeader organization={organization} />
    <SubscriptionInfoCards subscriptionInfoCards={subscriptionInfoCards} />
    <SubscriptionFeatures featureStatuses={featureStatuses} organizationName={organization.name} />
  </>;

export default SubscriptionsDashboard;
